import { isFeatureFlagEnabledByUserEmailDomain } from './feature-flags-storage';

/**
 * Whether the current user should have admin tools access.
 *
 * Currently this is derived from the same condition as the `isLeagueUser`
 * feature flag (e.g. @league.com email domain). That mapping may change;
 * this function remains the single place to check admin eligibility.
 *
 * Unlike regular feature flags, this check:
 * - Uses only the authenticated user's email domain (e.g. @league.com)
 * - Does not read localStorage, so it cannot be enabled via console or via
 *   the Feature Flags Settings UI (the `isLeagueUser` flag is hidden)
 * - Is not affected by the global auto-enable override toggle because hidden
 *   flags are excluded from override behavior
 */
export const isAdminUser = () =>
  isFeatureFlagEnabledByUserEmailDomain('isLeagueUser');
